import Page from '../classes/Page';
import galleryCarousel from "../components/landing/galleryCarousel";
import citySearch from "../components/landing/search";
import intlTelInput from "../components/landing/intlTelInput";
import scrollTo from "../components/landing/scrollTo";

import animation from "../components/landing/animation";
import feedback from "../components/landing/feedback";

const regularPage = new Page({
    name: 'regular',
    rootElementId: 'js-page-regular',
    onInit() {
        this
            .addComponent(galleryCarousel)
            .addComponent(citySearch)
            .addComponent(intlTelInput)
            .addComponent(feedback)
            .addComponent(scrollTo)
            .addComponent(animation)
    }
});

export default regularPage;
